import BigNumber from "bignumber.js";

export const PlayerLeaveLevel = 999;

export enum GameCodes {
  SugarBlast = "sugar-blast",
  SugarBlast2 = "sugar-blast-2",
  CoinDozer = "coin-dozer",
  CoinPusher = "coin-pusher",
  VikingBlast = "viking-blast",
  RoosterBlitz = "rooster-blitz",
  // viking alternative game code, to access rule and setting page only
  GemsOfVahalla = "gems-of-vahalla",
  OlympusGlory = "olympus-glory",
  CleopatrasTreasure = "cleopatras-treasure",
  GoldRushBonanza = "gold-rush-bonanza",
  PiratesTreasure = "pirates-treasure",
  HippoSplash = "hippo-splash",
  HunkCaiShen = "hunk-cai-shen",
  DearSenpai = "dear-senpai",

  Unknown = "unknown",
}

export enum GameShortCodes {
  SugarBlast = "sb",
  SugarBlast2 = "sb2",
  CoinDozer = "cd",
  VikingBlast = "vb",
  OlympusGlory = "og",
  RoosterBlitz = "rb",
  CleopatrasTreasure = "ct",
  GoldRushBonanza = "grb",
  PiratesTreasure = "pt",
  HippoSplash = "hs",
  HunkCaiShen = "hcs",
  DearSenpai = "ds",
}

export enum GameTitles {
  SugarBlast = "Sugar Blast",
  SugarBlast2 = "Sugar Blast Frenzy",
  CoinDozer = "Coin Pusher",
  VikingBlast = "Gems of Vahalla",
  OlympusGlory = "Olympus Glory",
  RoosterBlitz = "Rooster Blitz",
  CleopatrasTreasure = "Cleopatras Treasure",
  GoldRushBonanza = "Gold Rush Bonanza",
  PiratesTreasure = "Pirates Treasure",
  HippoSplash = "Hippo Splash",
  Unknown = "unknown",
  HunkCaiShen = "Hunk Cai Shen",
  DearSenpai = "Dear Senpai",
}

export const GameShortCodeArray = [
  GameShortCodes.SugarBlast,
  GameShortCodes.SugarBlast2,
  GameShortCodes.CoinDozer,
  GameShortCodes.RoosterBlitz,
  GameShortCodes.VikingBlast,
  GameShortCodes.OlympusGlory,
  GameShortCodes.CleopatrasTreasure,
  GameShortCodes.GoldRushBonanza,
  GameShortCodes.PiratesTreasure,
  GameShortCodes.HippoSplash,
  GameShortCodes.HunkCaiShen,
  GameShortCodes.DearSenpai,
];

export enum IdType {
  Unknown = "unknown",
  Rounds = "rounds",
  Spins = "spins",
  Plays = "plays",
  BetBatches = "betbatches",
}

export type GameInfoProps = {
  data: Record<string, unknown>;
};

export type RoundHistoryComponentProps = {
  roundHistory: RoundHistory;
  type: IdType;
  id: string;
};

export type Point = {
  x: number;
  y: number;
};

export type PayoutItem = {
  multiplier: number;
  symbolPoints: Point[];
  symbolId: number;
  count: number;
  payout: number;
  win: number;
};

export type SpinHistory = {
  id: string;
  level: number;
  reelMatrix: number[][];
  addedFreeSpin: number;
  payout: PayoutItem[];
  gameData: any;
  state: string;
  winAmount: string;
  mode: string;
  spinDate: string;
  playRefNumber: string;
  focus: boolean;
};

export type RoundHistory = {
  roundReferenceNumber: string;
  betAmount: number;
  lineAmount: number;
  winAmount: number;
  buyFreeSpin: boolean;
  buyFreeSpinRate: number;
  totalFreeSpin: number;
  startedDate: string;
  endedDate: string;
  endBalance: number;
  currencySymbol: string;
  state: string;
  spins: SpinHistory[];
  roundType: RoundType;
  lang: string;
};

export enum RoundType {
  Regular = 0,
  FreePlay = 1,
}

export type maxPayoutFormular = (maxPayout: number | BigNumber) => BigNumber;

export type CurrencySetting = {
  website: string;
  symbol: string;
  currency: string;
  minBet: number;
  maxBet: number;
  chipOptions: number[];
};
export type MatchedLine = {
  points: { x: number; y: number }[];
  win: number;
  beforeWin: number;
};
